import moment from 'moment'
import { Calendar } from 'primereact/calendar'
import React, { useEffect, useRef, useState } from 'react'
import flightIcon from '../../../assets/images/cargo_flight.svg'
import flightIconFilled from '../../../assets/images/Freighter_Grey.svg'
import minusIcon from '../../../assets/images/minus.svg'
import plusIcon from '../../../assets/images/plus.svg'
import truckIcon from '../../../assets/images/cargo_truck.svg'
// import { Dropdown } from '../../../common/DropDown'
// import { Dropdown } from "primereact/dropdown";
import { CommonDropDown } from '../../../common/Resusable/CommonDropDown'
import { ALLOWABLE_BOOKING_DATE } from '../../../configs/appConfigs'
import {
	getAircraftClassifications,
	AUTOCOMPLETE_TYPE,
	FLIGHT_ENQUIRY_FORM_FIELDS,
	getFlightTypes,
	PAGE_SUB_CATEGORY1,
	PAGE_PRIMARY_CATEGORY,
	BOOKING_PAGE_SUB_CATEGORY2
} from '../../../constants'
import MESSAGES from '../../../constants/Messages'
import { getAirportsByCode } from '../../../services/searchPanelServices'
import getCurrentUser from '../../../utils/getCurrentUser'
import { clearItemFromSessionStorage, setToSessionStorage, getBase64Decoded, getBase64Encoded } from '../../../utils/StorageUtils'
import { checkFlightFormat, padLeadingZeros } from '../../../utils/Validations'
import AirportAutocomplete from '../../AirportAutocomplete'
import { allowAlphaOnly, restrictSpaceSpecial, validateCarrierCodeRequired, removeError, hasError } from '../../ManageBooking/ListBooking/ListbookingValidations'
import FlightItem from '../FlightItem'
import { validateFormData } from '../formUtils'
import './flight-search.scss'
import { Alert } from '../../../common/Alert'
import { useTranslation } from 'react-i18next'
import { addError, pushPageData } from '../../../utils/analytics'
import pageNames from '../../../constants/pageNames'
import downArrow from '../../../assets/images/chevron-down.png'
import upArrow from '../../../assets/images/chevron-up.png'
import CommonInput from "../../../common/Resusable/CommonInput";
import { Divider } from '../../../common/Divider'
import CALENDAR_LOCALES from '../../../common/Calendar/calendarLocales'

// import FlightDetails from "../../FlightDetails";
const FlightSearch = ({
	getFlightEnquiryList,
	showErrorPopup,
	flightEnquiryError,
	flightEnquiryResponse,
	gsaAgentDetails,
	setEnquiredPresent
}) => {
	const [flightDate, setFlightDate] = useState(moment())
	const [currentResponseNumber, setCurrentresponseNumber] = useState(5);
	const [selectedOrigin, setSelectedOrigin] = useState(null)
	const [selectedDestination, setSelectedDestination] = useState(null)
	const [flightNo, setFlightNo] = useState(null)
	const [carrierCode, setCarrierCode] = useState('EY');
	const calendarRef = useRef(null)
	const [error, setError] = useState(null)
	const { t, i18n } = useTranslation(['labels', 'errors'])
	const [flightType, setFlightType] = useState("All")
	const [aircraftClassification, setAircraftClassification] = useState('All')
	const [showFlightNoValidation, setShowFlightNoValidation] = useState(false)
	const [advancedSearch, setAdvancedSearch] = useState(false);
	const [notificationType, setNotificationType] = useState(null)
	const [notificationMessage, setNotificationMessage] = useState('')
	const [searchRequest, setSearchRequest] = useState(null)
	const [flightDatefocused, setFlightDateFocused] = useState(false);

	const { agentDetails } = gsaAgentDetails
	const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';
	const calendarLocale = CALENDAR_LOCALES[i18n.language] || CALENDAR_LOCALES.en;
	const dateFormat = i18n.language === 'zh' ? 'yy-mm月-dd日' : 'dd M yy';

	useEffect(() => {
		if (
			flightEnquiryResponse &&
			flightEnquiryResponse.flightItineraryList.length === 0
		) {
			addError('ER039', i18n.getResource('en', 'errors', MESSAGES.NO_FLIGHTS))
		}
		if (flightEnquiryError) {
			addError(
				'ER076',
				i18n.getResource('en', 'errors', MESSAGES.PROCESS_REQUEST_FAILED)
			)
		}
		if (flightEnquiryResponse) {
			pushPageData(
				pageNames.FLIGHT_ENQUIRY,
				PAGE_PRIMARY_CATEGORY.E_SERVICES,
				PAGE_SUB_CATEGORY1.BOOKING,
				BOOKING_PAGE_SUB_CATEGORY2.ROUTING_ENQUIRY,
				null,
				searchRequest,
			)
			setSearchRequest(null)
		}
	}, [flightEnquiryError, flightEnquiryResponse])

	const validateFlightNoRegex = (flightNumber) => {
		if (!checkFlightFormat(flightNumber)) {
			setShowFlightNoValidation(true)
			setError({
				...error,
				[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER]:
					MESSAGES.INVALID_FLIGHT_NUMBER,
			})
		}
	}

	const validateFlightNo = (flightNo) => {
		setShowFlightNoValidation(false)
		let newFlightNumber
		if (flightNo) {
			if (flightNo.length < 4) {
				newFlightNumber = padLeadingZeros(flightNo, 4)
				setFlightNo(
					newFlightNumber
				)
				validateFlightNoRegex(newFlightNumber)
			}

			if (flightNo.length === 4 || flightNo.length === 5) {
				validateFlightNoRegex(flightNo)
			}
		}
	}

	const handleChangeOfFlightNo = (flightNo) => {
		setShowFlightNoValidation(false)
		if (flightNo.length <= 5) {
			setFlightNo(flightNo);
		}
	}

	const clearError = (key) => {
		const tempError = error ? { ...error } : null
		if (tempError) {
			tempError[key] = null
			setError(tempError)
		}
	}
	const [searchClicked, setsearchClicked] = useState(false)
	const userDetails = getCurrentUser()
	const searchFlights = () => {
		const error = validateFormData(
			selectedOrigin,
			selectedDestination,
			flightDate,
			flightNo,
			setShowFlightNoValidation
		)
		setCurrentresponseNumber(5)
		setError(error)

		if (!error && !showFlightNoValidation) {
			setsearchClicked(true)
			let request = {
				origin: selectedOrigin ? selectedOrigin.code : null,
				destination: selectedDestination ? selectedDestination.code : null,
				flightNumber: flightNo ? flightNo : null,
				carrierCode: flightNo && carrierCode ? carrierCode : null,
				flightType: flightType && flightType === 'T'
					? 'T,ET,IT'
					: flightType === 'All'
						? null
						: flightType,
				// aircraftClassification: aircraftClassification && aircraftClassification === 'A'
				// 		?null : aircraftClassification != 'All'
				// 			? aircraftClassification
				// 		: null,
				aircraftClassification: aircraftClassification && aircraftClassification != 'All'
					? aircraftClassification
					: null,
					
				flightDate: flightDate
					? moment(flightDate).format('DD-MMM-YYYY')
					: null,
				agentCode: userDetails ? userDetails.agentCode : null,
				currency: userDetails ? userDetails.currencyCode : null,
			}
			getFlightEnquiryList(request)
			const searchInput = request
			setSearchRequest(searchInput)
		}
	}

	useEffect(() => {
		setTimeout(() => {
			clearItemFromSessionStorage('flightParameterObj')
		}, 1000)
	}, [])


	const handleShowMore = (val) => {
		setCurrentresponseNumber(currentResponseNumber + 5)
	}

	const handleAdvanceSearch = (advancedSearch) => {
		setAdvancedSearch(!advancedSearch)
	}

	const handleSetError = (key, text) => {
		error
			? setError({
				...error,
				[key]: text,
			})
			: setError({
				[key]: text,
			})
	}

	const draftCallback = () => { }

	useEffect(() => {
		const userDetails = getCurrentUser()
		let defaultAirport = userDetails && userDetails.defaultAirportCode ?  userDetails.defaultAirportCode : userDetails?.stationCode
		if(agentDetails?.agentDefaultAirportCode){
			// defaultAirport = agentDetails?.agentStationCode
			defaultAirport = agentDetails && agentDetails.agentDefaultAirportCode ? agentDetails.agentDefaultAirportCode : agentDetails.agentStationCode;
		}
		if (userDetails && defaultAirport) {
			getAirportsByCode(defaultAirport)
				.then((defaultOrigin) => {
					setSelectedOrigin(defaultOrigin)
					pushPageData(
						pageNames.FLIGHT_ENQUIRY,
						PAGE_PRIMARY_CATEGORY.E_SERVICES,
						PAGE_SUB_CATEGORY1.BOOKING,
						BOOKING_PAGE_SUB_CATEGORY2.ROUTING_ENQUIRY
					)
				})
				.catch((error) => {
					addError('API_ERROR', error)
					pushPageData(
						pageNames.FLIGHT_ENQUIRY,
						PAGE_PRIMARY_CATEGORY.E_SERVICES,
						PAGE_SUB_CATEGORY1.BOOKING,
						BOOKING_PAGE_SUB_CATEGORY2.ROUTING_ENQUIRY
					)
					console.log(error)
				})
		}
	}, [])

	useEffect(() => {
		const airportDefault = agentDetails?.agentDefaultAirportCode || agentDetails?.agentStationCode;
		if (airportDefault) {
			getAirportsByCode(airportDefault)
				.then((defaultOrigin) => {
					setSelectedOrigin(defaultOrigin)
					pushPageData(
						pageNames.FLIGHT_ENQUIRY,
						PAGE_PRIMARY_CATEGORY.E_SERVICES,
						PAGE_SUB_CATEGORY1.BOOKING,
						BOOKING_PAGE_SUB_CATEGORY2.ROUTING_ENQUIRY
					)
				})
				.catch((error) => {
					addError('API_ERROR', error)
					pushPageData(
						pageNames.FLIGHT_ENQUIRY,
						PAGE_PRIMARY_CATEGORY.E_SERVICES,
						PAGE_SUB_CATEGORY1.BOOKING,
						BOOKING_PAGE_SUB_CATEGORY2.ROUTING_ENQUIRY
					)
					console.log(error)
				})
		}
	}, [agentDetails])

	const handleAlertClose = () => {
		setNotificationMessage('')
		setNotificationType(null)
	}

	

	return (
		<>
		<div className={`flight-search ${isRTL ? 'rtl' : ''}`}>

			{notificationMessage && notificationMessage !== '' && (
				<div className='cargo-portal-container pb-2'>
					<Alert
						showAlert={true}
						message={notificationMessage}
						setTimeout={true}
						onAlertClose={handleAlertClose}
						type={notificationType}
					/>
				</div>
			)}
			<div className='search-flight-header'>{t('COMMON.SEARCH_FLIGHTS')}</div>
			<div className='flight-enquiry-form-panel d-none d-lg-flex'>
				
				<div className='input-row'>
					<div className={`form-group common-autocomplete ${error && error[FLIGHT_ENQUIRY_FORM_FIELDS.ORIGIN]
							? 'red-border'
							: ''
				}`}>
						
						<div className="p-float-label input-wrapper">
							<AirportAutocomplete
								autoCompleteType={AUTOCOMPLETE_TYPE.ORIGIN}
								selectedOrigin={selectedOrigin}
								selectedDestination={selectedDestination}
								setSelectedOrigin={setSelectedOrigin}
								handleSetError={handleSetError}
								clearError={clearError}
								draftCallback={draftCallback}
								setNotificationMessage={setNotificationMessage}
								setNotificationType={setNotificationType}
							/>
							<label >
								{t('COMMON.SHP_FROM')}
							</label>
							<span className='search-panel__errormsg'>
								{/* {error && error[FLIGHT_ENQUIRY_FORM_FIELDS.ORIGIN]
								? t(error[FLIGHT_ENQUIRY_FORM_FIELDS.ORIGIN], {
								ns: 'errors',
								})
								: ''} */}
								{error && error[FLIGHT_ENQUIRY_FORM_FIELDS.ORIGIN]
											? t(error[FLIGHT_ENQUIRY_FORM_FIELDS.ORIGIN], {
												ns: 'errors',
											})
											: ''}
							</span>
						</div>
						{/* </div> */}
					</div>
					<div className={`form-group common-autocomplete ${error && error[FLIGHT_ENQUIRY_FORM_FIELDS.DESTINATION]
							? 'red-border'
							: ''
				}`}>
								<div class='p-float-label input-wrapper'>
									<AirportAutocomplete
										autoCompleteType={AUTOCOMPLETE_TYPE.DESTINATION}
										selectedOrigin={selectedOrigin}
										selectedDestination={selectedDestination}
										setSelectedDestination={setSelectedDestination}
										handleSetError={handleSetError}
										clearError={clearError}
										draftCallback={draftCallback}
										setNotificationMessage={setNotificationMessage}
										setNotificationType={setNotificationType}
									/>
									<label className=''>{t('COMMON.SHP_TO')}</label>
									<span className='search-panel__errormsg'>
										{error && error[FLIGHT_ENQUIRY_FORM_FIELDS.DESTINATION]
											? t(error[FLIGHT_ENQUIRY_FORM_FIELDS.DESTINATION], {
												ns: 'errors',
											})
											: ''}
									</span>
								</div>
							{/* </div> */}
					</div>
				</div>
				<div className='input-row'>
					<div className='form-group'>
					 {/* <div className='form-group common-autocomplete'> */}
						<div className={`p-float-label ${flightDatefocused ? 'custom-float-label' : ''}`}>
							<Calendar
							key={`flightDate-${i18n.language}`}
							className="form-item__field"
							// className='form-item__field form-control'
							ref={calendarRef}
						dateFormat={dateFormat}
							// value={moment(flightDate).toDate()}
							 value={flightDate ? moment(flightDate).toDate() : null}
							onFocus={(e) =>{clearError(FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTDATE), 
								setFlightDateFocused(true);
							} }
							onChange={(e) => {
								setFlightDate(e.value)
							}}
							minDate={moment().toDate()}
							maxDate={moment()
								.add(ALLOWABLE_BOOKING_DATE - 1, 'days')
								.toDate()}
							locale={calendarLocale}
							onBlur={({ target }) => {
								if (!target.value) {
								error
								? setError({
									...error,
									[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTDATE]:
										MESSAGES.VALID_SHIPPING_DATE,
								})
								: setError({
									[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTDATE]:
										MESSAGES.VALID_SHIPPING_DATE,
								})
								}
								setFlightDateFocused(false);
							}	
						}
							inputId="fromBookingDate"
								/>
							<label htmlFor="fromBookingDate">{t('COMMON.FLT_DATE')}</label>
							<span className='search-panel__errormsg'>
								{error && error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTDATE]
									? t(error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTDATE], {
										ns: 'errors',
									})
									: ''}
							</span>
						</div>
				
					</div>

					<div className='input-container'>
					 <div className={`form-group awb-input-section`}>

								<CommonInput
									type="text"
									label={t('COMMON.CODE')}
									value={carrierCode}
									maxLength="2"
									onKeyPress={(envt) => allowAlphaOnly(envt)}
									onChange={({ target }) => {
										setCarrierCode(target.value);
										// Clear carrier code error as user types
										if (error && error['carrierCode']) {
											setError({ ...error, carrierCode: null });
										}
									}}
									onFocus={() => {
										// Clear carrier code error on focus
										if (error && error['carrierCode']) {
											setError({ ...error, carrierCode: null });
										}
									}}
									onBlur={({ target }) => {
										// Validate carrier code on blur
										validateCarrierCodeRequired(
											flightNo,
											target.value,
											setError,
											"carrierCode"
										);
									}}
									error={error && error['carrierCode']
										? t(error["carrierCode"], { ns: "errors" })
										: ''}
									wrapperClassName={`awb-prefix`}
									
								/>

								<CommonInput
									type="text"
									label={t("COMMON.FLT_NO")}
									aria-invalid={showFlightNoValidation}
									value={flightNo}
									onKeyPress={(e) => restrictSpaceSpecial(e)}
									onChange={(e) => {
										handleChangeOfFlightNo(e.target.value);
										// Clear flight number error as user types
										if (error && error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER]) {
											setError({ ...error, [FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER]: null });
										}
									}}
									onFocus={() => {
										// Clear flight number error on focus
										if (error && error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER]) {
											setError({ ...error, [FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER]: null });
										}
									}}
									onBlur={(e) => {
										validateFlightNo(e.target.value);
									}}
									error={error && error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER]
										? t(error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER], { ns: "errors" })
										: ""}
									wrapperClassName={"awb-suffix"}
									// isOnlyErrorBorder
								/>

					{/* <CommonInput
					type="text"
					label={t('COMMON.CODE')}
					value={carrierCode}
					maxLength="2"
					onKeyPress={(envt) => {
						return allowAlphaOnly(envt);
						}}
					onChange={({ target }) => setCarrierCode(target.value)}
					onFocus={(e) => {
					removeError(e, setError);

					}}
					onBlur={(e) => {
					validateCarrierCodeRequired(
						flightNo,
						e.target.value,
						setError,
						"carrierCode"
					);
					}}
					error={error && error['carrierCode']
					?t(error["carrierCode"], { ns: "errors" })
					: ''}
					wrapperClassName={`awb-prefix`}
					/> */}

					{/* <CommonInput
					//       id="flightNumber"
													type="text"
						label={t("COMMON.FLT_NO")}
						
						aria-invalid={showFlightNoValidation}
						value={flightNo}
						onKeyPress={(e) => {
						return restrictSpaceSpecial(e);
						}}
						onFocus={(e) => {
										if (error && error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER] && error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER] != null) {
											error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER] = null
										} else {
											return ''
										}
									}}
						onChange={(e) => handleChangeOfFlightNo(e.target.value)}
						onBlur={(e) => {
						validateFlightNo(e.target.value);
						}}
					    error={error && error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER]
						? t(error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER], { ns: "errors" })
						: ""}		
						wrapperClassName={"awb-suffix"}
						isOnlyErrorBorder
              /> */}
            				</div>
					</div>
				   
					{/* <div
					className={`input-container  ${
							error && (error["carrierCode"] || error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER])
							? "input-container-error"
							: ""
							}`}
					>
							<input
							type="text"
							className='carrier-input border-0'
							
							aria-invalid={hasError("carrierCode", error)}
							maxLength="2"
							value={carrierCode}
							onKeyPress={(envt) => {
							return allowAlphaOnly(envt);
							}}
							onChange={({ target }) => setCarrierCode(target.value)}
							onBlur={(e) => {
							validateCarrierCodeRequired(
								flightNo,
								e.target.value,
								setError,
								"carrierCode"
							);
							}}
							onFocus={(e) => {
							removeError(e, setError);
							}}
							/>
					
					
					
					<div className="separator"></div>
						 <CommonInput
									id="flightNumber"
									type="text"
									label={t("COMMON.FLT_NO")}
									
									aria-invalid={showFlightNoValidation}
									value={flightNo}
									onKeyPress={(e) => {
									return restrictSpaceSpecial(e);
									}}
									onFocus={(e) => {
									if (
										error &&
										error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER] &&
										error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER] != null
									) {
										error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER] = null;
									} else {
										return "";
									}
									}}
									onChange={(e) => handleChangeOfFlightNo(e.target.value)}
									onBlur={(e) => {
									validateFlightNo(e.target.value);
									}}
									 error={error && error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER]
							? error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER]
							: ""}
                        							/>
					</div> */}

				</div>

				
					
				<div className='shipping-input-bottom'>

				{!advancedSearch ? (
				<>
				<div
				className="advanced-search-section"

				onClick={() => handleAdvanceSearch(advancedSearch)}
				>
				<span className="link-label">{`${t(
				"COMMON.ADV_SEARCH"
				)}`}</span>
				<img src={downArrow} alt="" className="custom-icon-size-down" />
				</div>
				<button
						type='button'
						className='primary-button'
						onClick={() => searchFlights()}
					>
						{t('COMMON.SEARCH')}
				</button>
				</>
				) : (
				<div
				className="advanced-search-section justify-content-start"
				onClick={() => handleAdvanceSearch(advancedSearch)}
				>
				<span className="link-label">{`${t(
				"COMMON.ADV_SEARCH"
				)}`}</span>
				<img src={upArrow} alt="" className="custom-icon-size-down" />
				</div>
				)}

				</div>
					
						
				{advancedSearch &&
				<div className="input-row">
					
					<CommonDropDown
					label={t('ROUTING_ENQUIRY.FLT_TYP')}
					className={"booking-status-dropdown"}
					value={flightType}
					options={getFlightTypes(t)}				
					onChange={(e) => {
					setFlightType(e.target.value);
					}}
					/>
					
					
					<CommonDropDown
					label={t("ROUTING_ENQUIRY.AIRCRAFT_CLASS")}
					className={"booking-status-dropdown"}
					value={aircraftClassification}
					options={getAircraftClassifications(t)}
					onChange={(e) => {
					setAircraftClassification(e.target.value);
					}}
				/>

              
				</div>
				
				}
				 {advancedSearch && (
				<div className="advanced-search-section">
				<button
				type="button"
				className="primary-button"
				onClick={() => searchFlights()}
				>
				{t("COMMON.SEARCH")}
				</button>
				</div>
				)}

				
				
			</div>

			{/* mobile view */}
			<div className='routing-enquiry-panel-mobile d-flex d-lg-none '>
				<div className='portal-col w-100 d-flex flex-column routing-enquiry-container-mobile'>
					<div className={`portal-row form-group w-100 ${error && error[FLIGHT_ENQUIRY_FORM_FIELDS.ORIGIN]
							? 'red-border'
							: ''
				}`}>
						<div className="p-float-label input-wrapper">
							<AirportAutocomplete
								autoCompleteType={AUTOCOMPLETE_TYPE.ORIGIN}
								selectedOrigin={selectedOrigin}
								selectedDestination={selectedDestination}
								setSelectedOrigin={setSelectedOrigin}
								handleSetError={handleSetError}
								clearError={clearError}
								draftCallback={draftCallback}
								setNotificationMessage={setNotificationMessage}
								setNotificationType={setNotificationType}
							/>
							<label >
								{t('COMMON.SHP_FROM')}
							</label>
							<span className='search-panel__errormsg'>
								{error && error[FLIGHT_ENQUIRY_FORM_FIELDS.ORIGIN]
								? t(error[FLIGHT_ENQUIRY_FORM_FIELDS.ORIGIN], {
								ns: 'errors',
								})
								: ''}
							</span>
						</div>
						{/* </div> */}
					</div>
					<div className={`portal-row form-group w-100 ${error && error[FLIGHT_ENQUIRY_FORM_FIELDS.DESTINATION]
							? 'red-border'
							: ''
				}`}>
				
								
								<div class='p-float-label input-wrapper'>
									<AirportAutocomplete
										autoCompleteType={AUTOCOMPLETE_TYPE.DESTINATION}
										selectedOrigin={selectedOrigin}
										selectedDestination={selectedDestination}
										setSelectedDestination={setSelectedDestination}
										handleSetError={handleSetError}
										clearError={clearError}
										draftCallback={draftCallback}
										setNotificationMessage={setNotificationMessage}
										setNotificationType={setNotificationType}
									/>
									<label className=''>{t('COMMON.SHP_TO')}</label>
									<span className='search-panel__errormsg'>
										{error && error[FLIGHT_ENQUIRY_FORM_FIELDS.DESTINATION]
											? t(error[FLIGHT_ENQUIRY_FORM_FIELDS.DESTINATION], {
												ns: 'errors',
											})
											: ''}
									</span>
								</div>
							{/* </div> */}
					</div>
					<div className='portal-row calendar-group form-group w-100'>
						<div className={`p-float-label ${flightDatefocused ? 'custom-float-label' : ''}`}>
							<Calendar
							key={`flightDate-${i18n.language}`}
							className='form-item__field form-control form-item__field'
							ref={calendarRef}
						dateFormat={dateFormat}
							value={moment(flightDate).toDate()}
							onFocus={(e) =>{clearError(FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTDATE), 
								setFlightDateFocused(true);
							} }
							onChange={(e) => {
								setFlightDate(e.value)
							}}
							minDate={moment().toDate()}
							maxDate={moment()
								.add(ALLOWABLE_BOOKING_DATE - 1, 'days')
								.toDate()}
							locale={calendarLocale}
							onBlur={({ target }) => {
								if (!target.value) {
								error
								? setError({
									...error,
									[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTDATE]:
										MESSAGES.VALID_SHIPPING_DATE,
								})
								: setError({
									[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTDATE]:
										MESSAGES.VALID_SHIPPING_DATE,
								})
								}
							}}
								/>
							<label className=''>{t('COMMON.FLT_DATE')}</label>
							<span className='search-panel__errormsg'>
								{error && error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTDATE]
									? t(error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTDATE], {
										ns: 'errors',
									})
									: ''}
							</span>
						</div>
				
					</div>
						<div className={`form-group awb-input-section`}>
							<CommonInput
								type="text"
								label={t('COMMON.CODE')}
								value={carrierCode}
								maxLength="2"
								onKeyPress={(envt) => {
									return allowAlphaOnly(envt);
								}}
								onChange={({ target }) => setCarrierCode(target.value)}
								onFocus={(e) => {
									removeError(e, setError);

								}}
								onBlur={(e) => {
									validateCarrierCodeRequired(
										flightNo,
										e.target.value,
										setError,
										"carrierCode"
									);
								}}
								error={error && error['carrierCode']
									? t(error["carrierCode"], { ns: "errors" })
									: ''}
								wrapperClassName={`awb-prefix`}
							/>
                    {/* <Divider/> */}
							<CommonInput
								//       id="flightNumber"
								type="text"
								label={t("COMMON.FLT_NO")}

								aria-invalid={showFlightNoValidation}
								value={flightNo}
								onKeyPress={(e) => {
									return restrictSpaceSpecial(e);
								}}
								onFocus={(e) => {
									if (
										error &&
										error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER] &&
										error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER] != null
									) {
										error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER] = null;
									} else {
										return "";
									}
								}}
								onChange={(e) => handleChangeOfFlightNo(e.target.value)}
								onBlur={(e) => {
									validateFlightNo(e.target.value);
								}}
								error={error && error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER]
									? t(error[FLIGHT_ENQUIRY_FORM_FIELDS.FLIGHTNUMBER], { ns: "errors" })
									: ""}
								wrapperClassName={"awb-suffix"}
								// isOnlyErrorBorder
							/>
						</div>
					
					{!advancedSearch ? (
					<div className='portal-row flex-column advancedsearch-search-container-mobile'>
						<a className='link d-flex align-items-center advanced-search-link' onClick={() => handleAdvanceSearch(advancedSearch)}>
					<span>{t('COMMON.ADV_SEARCH')}</span>
					<span >
						<img src={downArrow} alt="" className="custom-icon-size-down" />
					</span>
					</a>
					<button
								type='button'
								className='primary-button w-100'
								onClick={() => searchFlights()}
							>
							{t('COMMON.SEARCH')}
							</button>
					</div>
					) : (
						<div
							className='d-flex align-items-center portal-row'
							// style={{ cursor: 'pointer' }}
							onClick={() => handleAdvanceSearch(advancedSearch)}
						>
							<a className='link d-flex align-items-center advanced-search-link'>
								<span>{t('COMMON.ADV_SEARCH')}</span>
								<span >
									<img src={upArrow} alt="" className="custom-icon-size-down" />
								</span>
							</a>
						</div>
						
					)}
					{advancedSearch &&
				<div className='portal-row flex-column  w-100 advancedsearch-search-container-mobile'>
					
						<CommonDropDown
							label={t('ROUTING_ENQUIRY.FLT_TYP')}
							className={'loose-dimension-unit-dropdown'}
							 value={flightType}
							
							
							options={getFlightTypes(t)}
							
							onChange={(e) => {
							setFlightType(e.target.value);
							}}
						/>
						<CommonDropDown
							label={t("ROUTING_ENQUIRY.AIRCRAFT_CLASS")}
							className={'loose-dimension-unit-dropdown w-100'}
							 value={aircraftClassification}
							options={getAircraftClassifications(t)}
							onChange={(e) => {
							setAircraftClassification(e.target.value);
							}}
						/>
					
				</div>
				}

				{advancedSearch &&
				<div className="portal-row">
				<button type="button" className="primary-button w-100" onClick={() => searchFlights()}>
				{t("COMMON.SEARCH")}</button>
				</div>
				}
				</div>
			</div>
			</div>

			
				{searchClicked &&
					flightEnquiryResponse &&
					flightEnquiryResponse.flightItineraryList.length > 0 &&
					<div className={`flight-enquiry__search__title_scheduled ${isRTL ? 'rtl' : ''}`}>
						<div className='flight-result'>{t('ROUTING_ENQUIRY.SCD_FLT_RSLT')}</div>
						{/* <div className='col-12 col-lg-auto float-right'> */}
							<div className="icons-container" >
								{flightEnquiryResponse?.flightItineraryList?.length}{""} {t('COMMON.FLIGHTS')}
								{/* <div className='icons-item'>
									<img src={flightIcon} alt='Flight' title='Flight' />  {t('ROUTING_ENQUIRY.PASSENGER_FLIGHT')}
								</div> */}
								{/* <div className='icons-item'>
									<span className='freighterSpan'>
										<img src={flightIconFilled} alt='Flight' title='Flight' />
									</span>
									<span> {t('ROUTING_ENQUIRY.FREIGHTER_FLIGHT')}</span>

								</div> */}
								{/* <div className='icons-item'>
									<img src={truckIcon} alt='Flight' title='Flight' />  {t('ROUTING_ENQUIRY.TRUCK')}
								</div> */}
							{/* </div> */}
						</div>
					</div>}
			{/* </div> */}
			<div className={`flight-details__list ${isRTL ? 'rtl' : ''}`}>
				{searchClicked &&
					flightEnquiryResponse &&
					flightEnquiryResponse.flightItineraryList.length === 0 ? (
					<div className='no-data'>
						{t(MESSAGES.NO_FLIGHTS, { ns: 'errors' })}
					</div>
				) : (
					<></>
				)}
				<div className='all-flights-routing-enquiry'>
					{searchClicked &&
					flightEnquiryResponse &&
					flightEnquiryResponse.flightItineraryList.length ? (
					flightEnquiryResponse.flightItineraryList.slice(0, currentResponseNumber).map(
						(destinationAirport, index) => (
							<FlightItem
								destinationAirport={destinationAirport}
								key={index}
								selectedOrigin={selectedOrigin}
								selectedDestination={selectedDestination}
								flightDate={flightDate}
								showDropoffPickup={true}

								 />
						)
					)
				) : (
					<></>
				)}
				</div>
				
				{searchClicked &&
					flightEnquiryResponse &&
					(flightEnquiryResponse.flightItineraryList.length > 5 && flightEnquiryResponse.flightItineraryList.length >= currentResponseNumber) ?
					<p style={{ textAlign: "end", cursor: "pointer", padding: "10px" }} onClick={() => handleShowMore()}>{t('ROUTING_ENQUIRY.SHOW_MORE')}</p> : <></>}

				{searchClicked && flightEnquiryError &&
					<div className='no-data'>
						{t(MESSAGES.PROCESS_REQUEST_FAILED, { ns: 'errors' })}
					</div>}
			</div>
			</>
		
	)
}

export default FlightSearch
